"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var cache = new WeakMap();

// as paths are arrays of string, keys are automatically coerced to comma-joined strings
var reverseJsonPaths = function reverseJsonPaths(FIELD_KEYS_TO_PATHS) {
  var keys = Object.keys(FIELD_KEYS_TO_PATHS);
  var result = keys.reduce(function (obj, fieldKey) {
    var fieldInfo = FIELD_KEYS_TO_PATHS[fieldKey];
    if (Array.isArray(fieldInfo[0])) {
      var memberSchema = fieldInfo[1];
      Object.keys(memberSchema).forEach(function (memberFieldKey) {
        var memberPath = memberSchema[memberFieldKey];
        var fullKey = [].concat(_toConsumableArray(fieldInfo[0]), _toConsumableArray(memberPath));
        obj[fullKey] = fieldKey + "[]." + memberFieldKey;
      });
    } else {
      obj[fieldInfo] = fieldKey;
    }
    return obj;
  }, {});
  return result;
};

var reverseJsonPathsCached = function reverseJsonPathsCached(jsonPaths) {
  return cache.get(jsonPaths) || cache.set(jsonPaths, reverseJsonPaths(jsonPaths)).get(jsonPaths);
};

exports.default = reverseJsonPathsCached;


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-metadata-2/dist/reverseJsonPaths.js
// module id = 285
// module chunks = 0